var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7039 1.72305L6.4785 6.72969C6.3035 6.87734 6.13943 6.9375 5.99998 6.9375C5.86053 6.9375 5.67268 6.87682 5.54635 6.75463L0.296348 1.72305C0.0339578 1.47422 0.0254266 1.03398 0.276661 0.796094C0.526173 0.53291 0.943301 0.524352 1.20389 0.776442L5.99998 5.37344L10.7961 0.779688C11.0558 0.527606 11.4737 0.536164 11.7233 0.79934C11.9746 1.03398 11.9664 1.47422 11.7039 1.72305Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-down.6789ba0b63f26e0dc3239fb914bfa9d5.svg";